// extracted by LIB_CSS_EXTRACT_LOADER
import "./tooltip_module.css"
export default {"trigger":"trigger-GlwNv7","positioner":"positioner-Z9RG3p","popup":"popup-ec3lPB"};